import { CommonButton, Input, RippleEffect } from "components";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import { validation } from "./validation";

function AdministratorForm({ onSubmit, permission, addMemberLoading }) {
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={{ permission: permission || "", name: "", email: "" }}
      onSubmit={onSubmit}
      validationSchema={validation()}
    >
      {(props) => {
        return (
          <Form>
            <div className="form-group">
              <label className="form-label">{t("text.common.name")}</label>
              <Input
                className="form-control"
                placeholder="Enter Name"
                name="name"
                setFieldValue={props.handleChange}
              />
            </div>
            <div className="form-group">
              <label className="form-label">{t("text.adminAuth.email")}</label>
              <Input
                className="form-control"
                placeholder="Enter Email ID"
                type="email"
                name="email"
                setFieldValue={props.handleChange}
              />
            </div>
            <div className="d-flex justify-content-end">
              <RippleEffect>
                <CommonButton
                  variant="danger"
                  type="submit"
                  loading={addMemberLoading}
                >
                  {t("text.common.submit")}
                </CommonButton>
              </RippleEffect>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

export default AdministratorForm;
